export const tenure = [
  {
    id: "1",
    name: "정규직",
  },
  {
    id: "2",
    name: "계약직",
  },
  {
    id: "3",
    name: "출산 및 육아휴직",
  },
  {
    id: "4",
    name: "일반휴직",
  },
  {
    id: "5",
    name: "퇴사",
  },
];

export const resp = [
  {
    id: "1",
    name: "CEO",
  },
  {
    id: "2",
    name: "Head",
  },
];

export const ny = [
  {
    id: "1",
    name: "Yes",
  },
  {
    id: "0",
    name: "No",
  },
];

export const div = [
  {
    id: "BD",
    name: "Bussiness Development",
  },
  {
    id: "BDP",
    name: "Business Development and Promotion",
  },
  {
    id: "CEO",
    name: "CEO",
  },
  {
    id: "CMS",
    name: "Core Management Support",
  },
  {
    id: "CS",
    name: "Companion Success",
  },
  {
    id: "CO",
    name: "Clinical Operaion",
  },
  {
    id: "DM",
    name: "Data Management",
  },
  {
    id: "MW",
    name: "Medical Writing",
  },
  {
    id: "OF",
    name: "Operational Finance",
  },
  {
    id: "PR",
    name: "Promotion",
  },
  {
    id: "SA",
    name: "Statistical Analysis",
  },
  {
    id: "SRD",
    name: "Software Research and Development",
  },
];

export const solarLunar = [
  {
    id: "1",
    name: "양력",
  },
  {
    id: "0",
    name: "음력",
  },
];

export const jd = [
  {
    id: "Associate",
    name: "Associate",
  },
  {
    id: "CEO",
    name: "CEO",
  },
  {
    id: "Chief Technology Developer",
    name: "Chief Technology Developer",
  },
  {
    id: "CPM",
    name: "CPM",
  },
  {
    id: "CRA",
    name: "CRA",
  },
  // {
  //   id: "CTA",
  //   name: "CTA",
  // },
  {
    id: "SSU",
    name: "SSU",
  },
  {
    id: "DPM",
    name: "DPM",
  },
  {
    id: "DRM",
    name: "DRM",
  },
  {
    id: "Head of BDP",
    name: "Head of BDP",
  },
  {
    id: "Head of CO",
    name: "Head of CO",
  },
  {
    id: "Head of DM",
    name: "Head of DM",
  },
  {
    id: "Head of MW",
    name: "Head of MW",
  },
  {
    id: "Head of QA",
    name: "Head of QA",
  },
  {
    id: "Head of PV",
    name: "Head of PV",
  },
  {
    id: "Head of RA",
    name: "Head of RA",
  },
  {
    id: "Head of SA",
    name: "Head of SA",
  },
  {
    id: "Head of SRD",
    name: "Head of SRD",
  },
  // {
  //   id: "MW",
  //   name: "MW",
  // },
  {
    id: "MWA",
    name: "MWA",
  },
  {
    id: "PVA",
    name: "PVA",
  },
  {
    id: "QAA",
    name: "QAA",
  },
  {
    id: "RAA",
    name: "RAA",
  },
  {
    id: "SA",
    name: "SA",
  },
  {
    id: "SP",
    name: "SP",
  },
];

export const employeeTabItems = [
  {
    id: "project",
    name: "Project List",
  },
];
